<template>
    <div>
        <div class="field has-addons">
            <div class="control">
                <input class="input is-small" v-model.number="currentSalary" v-on:keypress="isNumber(event)" type="number" style="max-width:140px">
            </div>
            <div class="control">
                <input class="button is-small is-success" @click="updateSalary()" :value="$t('input.update')" style="max-width: 75px;">
            </div>
            <a v-if="userSalary.length > 0" v-on:click="showSalaryHistory = !showSalaryHistory" class="button is-small is-info" style="margin-left:10px">
                {{ $t("settings.resTable.showHistory") }}
            </a>
        </div>
        <table class="table is-narrow" v-if="showSalaryHistory">
            <thead>
                <tr><th colspan="2">{{$t("settings.resTable.salaryHistory")}}</th></tr>
            </thead>
            <tbody>
                <tr v-for="salary in invertedSalaryHistory" v-bind:key="salary['.key']"> 
                    <td>{{ returnDate(salary.timestamp) }}</td>
                    <td>{{ returnNumberFormatted(salary.value) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import firebase from '@/firebase'
import _ from 'lodash'
import moment from 'moment'

export default {
    name: 'InputCustomProject',
    props: {
        user: Object,
    },
    data() {
      return {
          error: false,
          currentSalary: 0,
          showSalaryHistory: false
      }
    },
      firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        return {
            salaryHistory: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + this.user['.key'] + '/salaryHistory').orderByKey(),
                asObject: false
            },
            userSalary: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + this.user['.key'] + '/salaryHistory').limitToLast(1),
                asObject: false,
                readyCallback() {
                    if(this.userSalary) {
                        const salary = _.get(this.userSalary[0], 'value')
                        if(salary) {
                            this.currentSalary = salary
                        } else {
                            this.currentSalary = 0
                        }
                    } else {
                        this.currentSalary = 0
                    }
            }
          },
        }
    },
    computed: {
        invertedSalaryHistory() {
            return this.salaryHistory.reverse()
        }
    },
    methods: {
        returnNumberFormatted(number) {
            return number.toLocaleString(this.$i18n.locale)
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        returnDate(date) {
            return moment(date).format("DD/MM/YYYY")
        },
        updateSalary() {
            const userid = JSON.parse(localStorage.getItem('profile')).user_id;
            try {
                let newSalary = {
                    'updatedBy': userid,
                    'timestamp': moment().format(),
                    'value': this.currentSalary
                }
                this.$firebaseRefs.userSalary.push(newSalary)

            } catch(error) {
                this.error = error
            } finally {
                if(!this.error) {
                    this.$snotify.success(this.$i18n.t('messages.infoSaved'), {
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                    });
                } else {
                    this.$snotify.warning(this.$i18n.t('messages.errorMessage'), {
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                    });  
                }
            }
        }
    }
}
</script>

<style>

</style>
